import { AxiosInstance, CancelTokenSource } from 'axios';

import * as common from '../../../../../../typings/api/skymap/rest/v0/.common';
import * as types from '../../../../../../typings/api/skymap/rest/v0/project';

export class ProjectService implements types.Handlers {
  constructor(
    private axios: AxiosInstance,
    private cancelTokenSource?: CancelTokenSource,
  ) {}
  async getProjectUserTagsV1(
    params: types.GetProjectUserTagsV1Parameters,
  ): Promise<types.GetProjectUserTagsV1Response> {
    return (
      await this.axios.get(`/projects/${params.path.projectId}/users/${params.path.userId}/tags-v1`)
    ).data;
  }
  async putProjectUserTagsV1(
    params: types.PutProjectUserTagsV1Parameters,
  ): Promise<types.GetProjectUserTagsV1Response> {
    return (
      await this.axios.put(
        `/projects/${params.path.projectId}/users/${params.path.userId}/tags-v1`,
        params.body,
      )
    ).data;
  }

  async getAll(params: types.GetAllParameters): Promise<types.GetAllProjectsResponse> {
    return (await this.axios.get(`/projects`)).data;
  }

  async getBasicProjectInformationList(): Promise<types.GetBasicProjectInformationListResponse> {
    return (await this.axios.get(`/projects/list`)).data;
  }

  create(params: types.CreateParameters): Promise<types.CreateProjectResponse> {
    throw new Error('Method not implemented.');
  }
  async update(params: types.UpdateParameters): Promise<types.SingleProjectResponse> {
    const { data } = await this.axios.put<types.SingleProjectResponse>(
      `/projects/${params.path.id}`,
      params.body,
    );
    return data;
  }

  async fetchProjectsGeodata(
    params: types.FetchProjectsGeodataParameters,
  ): Promise<types.FetchGeodataResponse> {
    return (
      await this.axios.get(`/projects/${params.path.projectId}/geodata`, {
        cancelToken: this.cancelTokenSource?.token,
      })
    ).data;
  }
  async getProjectAssets(
    params: types.GetProjectAssetsParameters,
  ): Promise<types.GetProjectAssetsResponse> {
    return (await this.axios.get(`/projects/${params.path.projectId}/assets`)).data;
  }
  async getProjectModels(
    params: types.GetProjectModelsParameters,
  ): Promise<types.GetProjectModelsResponse> {
    return (await this.axios.get(`/projects/${params.path.projectId}/models`)).data;
  }
  async getScans(params: types.GetScansParameters): Promise<types.GetProjectScansResponse> {
    return (await this.axios.get(`/projects/${params.path.projectId}/scans`)).data;
  }
  async getOrthoTiles(
    params: types.GetOrthoTilesParameters,
  ): Promise<types.GetProjectOrthoTilesResponse> {
    return (await this.axios.get(`/projects/${params.path.projectId}/ortho-tiles`)).data;
  }
  async getPointClouds(
    params: types.GetPointCloudsParameters,
  ): Promise<types.GetProjectPointCloudsResponse> {
    return (await this.axios.get(`/projects/${params.path.projectId}/point-clouds`)).data;
  }

  async getTerrainModels(
    params: types.GetTerrainModelsParameters,
  ): Promise<types.GetProjectTerrainModelsResponse> {
    return (await this.axios.get(`/projects/${params.path.projectId}/terrain-models`)).data;
  }

  registerGeodataNotificationUrl(
    params: types.RegisterGeodataNotificationUrlParameters,
  ): Promise<types.RegisterGeodataNotificationUrlResponse> {
    throw new Error('Method not implemented.');
  }
  getSharedView(params: types.GetSharedViewParameters): Promise<common.FetchSharedViewResponse> {
    throw new Error('Method not implemented.');
  }
  async getById(params: types.GetByIdParameters): Promise<common.FindProjectResponse> {
    return (await this.axios.get(`/projects/find?projectId=${params.query.projectId}`)).data;
  }
  async removeUserFromProject(
    params: types.RemoveUserFromProjectParameters,
  ): Promise<common.MessageOnlyResponse> {
    return (
      await this.axios.delete(`/projects/${params.path.projectId}/users/${params.path.userId}`)
    ).data;
  }
  addUsersToProjects(
    params: types.AddUsersToProjectsParameters,
  ): Promise<common.MessageOnlyResponse> {
    throw new Error('Method not implemented.');
  }
  async getProjectUsers(
    params: types.GetProjectUsersParameters,
  ): Promise<types.GetProjectUsersResponse> {
    return (await this.axios.get(`/projects/projectusers`)).data;
  }
  getPlatformSettings(
    params: types.GetPlatformSettingsParameters,
  ): Promise<types.PlatformSettingsResponse> {
    throw new Error('Method not implemented.');
  }
  orgNumberExists(params: types.OrgNumberExistsParameters): Promise<types.OrgnumberExistsResponse> {
    throw new Error('Method not implemented.');
  }
  mailParticipants(params: types.MailParticipantsParameters): Promise<common.MessageOnlyResponse> {
    throw new Error('Method not implemented.');
  }
  getProjectTransferRequest(
    params: types.GetProjectTransferRequestParameters,
  ): Promise<types.GetProjectTransferResponse> {
    throw new Error('Method not implemented.');
  }
  executeProjectTransferRequest(
    params: types.ExecuteProjectTransferRequestParameters,
  ): Promise<common.MessageOnlyResponse> {
    throw new Error('Method not implemented.');
  }
  sendProjectTransferRequest(
    params: types.SendProjectTransferRequestParameters,
  ): Promise<common.MessageOnlyResponse> {
    throw new Error('Method not implemented.');
  }
  fetchTimelineContainer(
    params: types.FetchTimelineContainerParameters,
  ): Promise<types.FetchTimelineContainersResponse> {
    throw new Error('Method not implemented.');
  }
  createTimelineContainer(
    params: types.CreateTimelineContainerParameters,
  ): Promise<types.CreateTimelineContainerResponse> {
    throw new Error('Method not implemented.');
  }
  removeAssetDynamic(
    params: types.RemoveAssetDynamicParameters,
  ): Promise<types.SingleProjectResponse> {
    throw new Error('Method not implemented.');
  }
  removeModel(params: types.RemoveModelParameters): Promise<types.SingleProjectResponse> {
    throw new Error('Method not implemented.');
  }
  async getCadFilesV1(params: types.GetCadFilesV1Parameters): Promise<types.GetCadFilesResponse> {
    return (await this.axios.get(`/projects/${params.path.projectId}/cad-files-v1`)).data;
  }
}
